<template>
    <!-- BEGIN FOOTER -->
    <div class="footer-wrapper">
        <div class="footer-section f-section-1">
            <p class="terms-conditions">
                © {{ new Date().getFullYear() }} <a target="_blank" href="https://dynamicmarkets.com/">Dynamic Markets</a> is a trading name of Global
                Dynamic Markets Limited. Global Dynamic Markets Limited is licensed and regulated by the Financial Services
                Commission of Mauritius and hold an Investment Dealer (Full Service Dealer Excluding Underwriting) License
                bearing license number GB21026278. The company registered office address is 7A Mayer Street, Port-Louis,
                Republic of Mauritius.
                <a href="https://dynamicmarkets.com/docs/Cookies_Policy.pdf" target="_blank">Cookie Preferences</a>,
                <a href="https://dynamicmarkets.com/docs/Data_Protection_Policy.pdf" target="_blank">Privacy</a>, and
                <a href="https://dynamicmarkets.com/docs/Terms_of_Use.pdf" target="_blank">Terms and
                    Conditions</a>.
            </p>
        </div>
        <div class="footer-section f-section-2">
        </div>
    </div>
    <!-- END FOOTER -->
</template>
